import React from "react";
import CommonImage from "../image/CommonImage";

export default function ProgramCard({ item }) {
  return (
    <div
      className="program-item"
      onClick={() => handleProgramClick(item)}
    >
      <div
        className={`item-card ${
          selectedProgram?.id === item.id ? "active" : ""
        }`}
      >
        <div className="program-icon">
          <CommonImage
            src={item.icon_url}
            className="img-icon"
            alt="Program Icon"
          />
        </div>
        <div className="item-content">
          <h4 className="title">{item.name}</h4>
        </div>
      </div>
    </div>
  );
}
